import store from '@/store/store'
import { getLoginModuleData } from '@/services/api/module/ModuleService'

export default function guard(to, from, next) {
    let moduleToken = getModuleToken_FromParams()
    if (
        process.env.VUE_APP_BY_PASS_LOGIN === 'false' &&
        moduleToken === undefined
    )
        // ignore guard if exist token in URL
        callSecureGuard(to, from, next)
    // Ignore login data if Vue Environment Var "VUE_APP_BY_PASS_LOGIN" is "true"
    next()
}

/**
 * @description
 * Management login and application routes with user data login
 * @return void
 */
function callSecureGuard(to, from, next) {
    let isAuthenticated = !!(localStorage.getItem('user-token') || '')

    if (!isAuthenticated) {
        getLoginModuleData() // Go to mod_login
            .then(response => {
                store.dispatch('AuthModule/logoutActions') // delete local storage user data
                let urlLoginModule = response.data.g_login_module.url_module
                window.location = urlLoginModule
                console.log('401: NO AUTORIZADO')
            })
            .catch(err => {
                console.log('Error get Module URL')
            })
        return
    }
}

/**
 * @description
 * Get module token from params
 * @return {void}
 */
const getModuleToken_FromParams = () => {
    try {
        return window.location.search.substr(1).split('=')[1]
    } catch (err) {
        return undefined
    }
} // end function
